import React, { useState, useEffect } from 'react'
import Loader from '../../../presentationals/Loader/Loader.component'
import Pagination from '@mui/material/Pagination';
import moment from 'moment'
import { LineChart, Line, Cell, Pie, PieChart, BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { getAmuAgentDashboadSuymmary, getAmuAgentDashboadOverviewListByData, getAmuAgentActivityTrendsByDate, getAmuAgentLeadsconversionByDate, getAmuAgentLeadsTopPerformerByDate, getAssugbedAmuAgentDetailsByData, getAllstateListDistrictByType, DownloadAmuAgentDashboardList, getDealerAgentMapsInfoByData } from '../maketingComponents/actioncreator';
import CustomMapComponent from './CustomMapsComponent';
const size = 10;

export default function AgentDashboard({ admin }) {
    const [stateList, setStateList] = useState([])
    const [districtList, setDistrcitList] = useState([])
    const [dealerLocaleData, setDealerLocaledata] = useState([])

    const [loader, setLoader] = useState(false)
    const [StatsData, setStatsData] = useState({})

    const [dealerPopup, setDealerPopup] = useState({ show: false, data: [], id: "" })
    const [topDealersList, setTopDealersList] = useState([])
    const [dealersData, setdealersData] = useState([])
    const [dealersDataItems, setDealersDataItems] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [popupPageNo, setpopupPageNo] = useState(1)
    const [TotalpopupPage, setTotalpopupPageNo] = useState(0)

    const [payload, setPayload] = useState({
        startDate: moment().startOf('year').format('YYYY-MM-DD'),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
        productType: "", city: "", state: ""
    })

    const [PieData, setPieData] = useState([
        { name: "Conversion Rate", value: 0 },
        { name: "Non Conversion Rate", value: 0 },
    ])
    const [vehicleTypeList, setvehicleTypeList] = useState([
        { month: "", leadsAssigned: 0, leadsConverted: 0 },
    ])

    const handlechange = (e, type) => {
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
        if (type == "state") {
            const ar = stateList?.filter((el) => el?.state == e.target.value)
            setDistrcitList(ar?.[0]?.cities || [])
        }
    }

    useEffect(() => {
        APicall()
    }, [])

    const APicall = () => {
        getAllstateListDistrictByTypeFn()
        getDealerAgentMapsInfoByDataFn()
        getAmuAgentDashboadSuymmaryFn()
        getAmuAgentDashboadOverviewListByDataFn(1)
        getAmuAgentActivityTrendsByDateFn()
        getAmuAgentLeadsconversionByDateFn()
        getAmuAgentLeadsTopPerformerByDateFn()
        setCurrentPage(1)
    }

    const getDealerAgentMapsInfoByDataFn = () => {
        const start = moment(payload?.startDate)?.format("DD-MM-YYYY");
        const end = moment(payload?.endDate)?.format("DD-MM-YYYY");
        getDealerAgentMapsInfoByData(start, end, payload?.state, payload?.city, payload?.productType, "AMU Agent", callback => {
            setDealerLocaledata(callback?.data ?? [])
        })
    }

    const getAllstateListDistrictByTypeFn = () => {
        getAllstateListDistrictByType("AMU Agent", callback => {
            setStateList(callback?.data || [])
        })
    }

    const getAmuAgentDashboadSuymmaryFn = () => {
        const start = moment(payload?.startDate).format("DD-MM-YYYY")
        const end = moment(payload?.endDate).format("DD-MM-YYYY")

        setLoader(true)
        getAmuAgentDashboadSuymmary(start, end, payload?.state, payload?.city, payload?.productType, callback => {
            setLoader(false)
            if (callback?.status == 200) {
                setStatsData(callback?.data)
            } else {
                setStatsData({})
            }
        })
    }
    const getAmuAgentDashboadOverviewListByDataFn = (page) => {
        const start = moment(payload?.startDate).format("DD-MM-YYYY")
        const end = moment(payload?.endDate).format("DD-MM-YYYY")

        setLoader(true)
        getAmuAgentDashboadOverviewListByData(start, end, size, page, payload?.state, payload?.city, payload?.productType, callback => {
            setLoader(false)
            if (callback?.status == 200) {
                setdealersData(callback?.data?.amuAgents)
                setDealersDataItems(callback?.data?.totalPages)
            } else {
                setStatsData({})
            }
        })
    }

    const getAmuAgentActivityTrendsByDateFn = () => {
        const start = moment(payload?.startDate).format("DD-MM-YYYY")
        const end = moment(payload?.endDate).format("DD-MM-YYYY")

        setLoader(true)
        getAmuAgentActivityTrendsByDate(start, end, payload?.state, payload?.city, payload?.productType, callback => {
            setLoader(false)
            if (callback?.status == 200) {
                setvehicleTypeList(callback?.data)
            } else {
                setvehicleTypeList([])
            }
        })
    }
    const getAmuAgentLeadsconversionByDateFn = () => {
        const start = moment(payload?.startDate).format("DD-MM-YYYY")
        const end = moment(payload?.endDate).format("DD-MM-YYYY")

        setLoader(true)
        getAmuAgentLeadsconversionByDate(start, end, payload?.state, payload?.city, payload?.productType, callback => {
            setLoader(false)
            if (callback?.status == 200) {
                setPieData([
                    { name: "Conversion Rate", value: callback?.data?.conversionRate },
                    { name: "Non Conversion Rate", value: callback?.data?.nonConversionRate },
                ])
            } else {
                setPieData([
                    { name: "Conversion Rate", value: 0 },
                    { name: "Non Conversion Rate", value: 0 },
                ])
            }
        })
    }
    const getAmuAgentLeadsTopPerformerByDateFn = () => {
        const start = moment(payload?.startDate).format("DD-MM-YYYY")
        const end = moment(payload?.endDate).format("DD-MM-YYYY")

        setLoader(true)
        getAmuAgentLeadsTopPerformerByDate(start, end, payload?.state, payload?.city, payload?.productType, callback => {
            setLoader(false)
            if (callback?.status == 200) {
                setTopDealersList(callback?.data)
            } else {
                setTopDealersList([])
            }
        })
    }

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        getAmuAgentDashboadOverviewListByDataFn(value)

    };
    const handlePageChangePopup = (event, value) => {
        setpopupPageNo(value);
        const start = moment(payload?.startDate).format("DD-MM-YYYY")
        const end = moment(payload?.endDate).format("DD-MM-YYYY")
        setLoader(true)
        getAssugbedAmuAgentDetailsByData(dealerPopup?.id, start, end, value, size, callback => {
            setLoader(false)
            setTotalpopupPageNo(callback?.data?.totalPages)
            setDealerPopup((prev) => ({ ...prev, data: callback?.data?.dealers }))
        })

    };

    const handleDealerPopup = (value, d, data) => {
        const start = moment(payload?.startDate).format("DD-MM-YYYY")
        const end = moment(payload?.endDate).format("DD-MM-YYYY")
        setLoader(true)
        getAssugbedAmuAgentDetailsByData(data.communityId, start, end, popupPageNo, size, callback => {
            setLoader(false)
            setTotalpopupPageNo(callback?.data?.totalPages)
            setDealerPopup({ show: value, data: callback?.data?.dealers, id: data.communityId })
        })
    }

    const handleDownload = () => {
        const start = moment(payload?.startDate).format("DD-MM-YYYY")
        const end = moment(payload?.endDate).format("DD-MM-YYYY")
        setLoader(true)
        DownloadAmuAgentDashboardList(start, end, payload?.state, payload?.city, payload?.productType, callback => {
            setLoader(false)
        })
    }


    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            <div className='dealerDashboard'>
                <div className='container-fluid' style={{ marginTop: '90px' }}>
                    <div className="row" >
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">Start Date</label>
                            <input type='date' className='form-control' value={payload.startDate} onChange={(e) => handlechange(e, "startDate")} />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">End Date</label>
                            <input type='date' className='form-control' value={payload.endDate} onChange={(e) => handlechange(e, "endDate")} />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">State</label>
                            <select className='form-control' value={payload.state} onChange={(e) => handlechange(e, "state")}>
                                <option value={""}>Select State</option>
                                {
                                    stateList?.length > 0 ? stateList?.map((val, id) => {
                                        return (
                                            <option value={val?.state}>{val?.state}</option>
                                        )
                                    })
                                        : ""}
                            </select>
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">City</label>
                            <select className='form-control' value={payload.city} onChange={(e) => handlechange(e, "city")}>
                                <option value={""}>Select City</option>
                                {
                                    districtList?.length > 0 ? districtList?.map((val) => {
                                        return (
                                            <option value={val}>{val}</option>
                                        )
                                    })
                                        : ""
                                }
                            </select>
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">Product type</label>
                            <select className='form-control' value={payload.productType} onChange={(e) => handlechange(e, "productType")}>
                                <option value="">Select Product</option>
                                <option value="L3">Three-Wheeler L3</option>
                                <option value="L5">Three-Wheeler L5</option>

                            </select>
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <button style={{
                                marginTop: '24px', padding: '10px',
                                color: " rgb(43, 120, 255)",
                                border: "1px solid rgb(43, 120, 255)",
                                backgroundColor: "rgb(255, 255, 255)",
                                marginTop: "28px",
                                padding: "10px",
                                borderRadius: "5px"
                            }}
                                onClick={() => APicall()}>
                                Apply
                            </button>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#5a57b71a", padding: '19px 15px' }}>
                                    <svg width="24" height="26" viewBox="0 0 24 26" fill="#5B93FF1a" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.2205 0.0697543C1.72539 0.45946 0.973331 2.06719 1.64696 3.4338C2.34407 4.84819 4.26656 5.18825 5.40844 4.09918C6.66723 2.89869 6.246 0.779821 4.626 0.163523C4.23738 0.0156681 3.59299 -0.0273162 3.2205 0.0697543ZM11.406 0.0831905C10.7213 0.267084 10.1098 0.774014 9.81516 1.40198C9.6762 1.69821 9.66149 1.79214 9.66149 2.38425C9.66149 3.01421 9.66873 3.05344 9.85375 3.42168C10.752 5.2092 13.2944 5.17732 14.1526 3.36771C14.3223 3.00982 14.3355 2.939 14.3355 2.38425C14.3355 1.8304 14.3221 1.75833 14.1539 1.40369C13.8139 0.686622 13.1823 0.190053 12.4325 0.0502832C12.0283 -0.025039 11.7791 -0.0170683 11.406 0.0831905ZM19.614 0.0831905C18.9098 0.272322 18.3722 0.726532 18.051 1.40369C17.8827 1.75867 17.8695 1.83001 17.8695 2.38726C17.8695 2.96724 17.8769 3.00311 18.0841 3.42185C18.4441 4.14922 19.0591 4.59643 19.8688 4.71969C20.799 4.86134 21.7142 4.44402 22.2222 3.64662C22.6346 2.99924 22.6904 2.04959 22.3566 1.35524C21.8695 0.341666 20.6893 -0.205687 19.614 0.0831905ZM1.6115 5.6543C1.17471 5.76002 0.620216 6.05084 0.289845 6.34752L0 6.60781V7.4281V8.24833H3.7905H7.58099V7.45953V6.67072L7.27667 6.38327C6.92772 6.05363 6.44253 5.79105 5.94373 5.66193C5.49297 5.54527 2.08677 5.5393 1.6115 5.6543ZM9.80399 5.66238C9.35831 5.7795 8.84246 6.05175 8.50137 6.34973L8.20799 6.6061V7.42725V8.24833H12H15.792L15.7763 7.41096L15.7605 6.5736L15.4329 6.31005C15.0449 5.998 14.6113 5.77654 14.157 5.65834C13.6905 5.53696 10.2691 5.54015 9.80399 5.66238ZM18.0237 5.66113C17.5917 5.77728 17.1494 6.00654 16.7721 6.31005L16.4445 6.5736L16.4287 7.41096L16.413 8.24833H20.2065H24L23.9843 7.41096L23.9685 6.5736L23.6265 6.29821C23.2237 5.97386 22.8432 5.77978 22.3748 5.65959C21.9003 5.53793 18.4774 5.53912 18.0237 5.66113ZM1.539 10.6702C1.539 10.6871 2.21171 11.43 3.03399 12.3213L4.52893 13.9416L11.9972 13.9395L19.4655 13.9373L20.805 12.4841C21.5417 11.6849 22.2175 10.9429 22.3068 10.8352L22.469 10.6395H12.004C6.24828 10.6395 1.539 10.6533 1.539 10.6702ZM5.28458 14.7529C5.34916 14.8234 6.39243 15.9565 7.60299 17.2711L9.80399 19.6612V22.8424C9.80399 25.3622 9.81881 26.0186 9.87524 25.9996C9.91446 25.9864 10.9015 25.6827 12.0688 25.3246L14.1911 24.6735L14.1921 22.1594L14.193 19.6453L16.4587 17.1879C17.7049 15.8365 18.733 14.7069 18.7435 14.6778C18.7551 14.6453 16.1285 14.6248 11.9648 14.6248H5.1671L5.28458 14.7529Z" fill="#5B93FF" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.totalAgents ?? 0}</b></h3>
                                    <h6>Total Urja Agents</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#5a57b71a", padding: '19px 15px' }}>
                                    <svg width="24" height="26" viewBox="0 0 24 26" fill="#5B93FF1a" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.2205 0.0697543C1.72539 0.45946 0.973331 2.06719 1.64696 3.4338C2.34407 4.84819 4.26656 5.18825 5.40844 4.09918C6.66723 2.89869 6.246 0.779821 4.626 0.163523C4.23738 0.0156681 3.59299 -0.0273162 3.2205 0.0697543ZM11.406 0.0831905C10.7213 0.267084 10.1098 0.774014 9.81516 1.40198C9.6762 1.69821 9.66149 1.79214 9.66149 2.38425C9.66149 3.01421 9.66873 3.05344 9.85375 3.42168C10.752 5.2092 13.2944 5.17732 14.1526 3.36771C14.3223 3.00982 14.3355 2.939 14.3355 2.38425C14.3355 1.8304 14.3221 1.75833 14.1539 1.40369C13.8139 0.686622 13.1823 0.190053 12.4325 0.0502832C12.0283 -0.025039 11.7791 -0.0170683 11.406 0.0831905ZM19.614 0.0831905C18.9098 0.272322 18.3722 0.726532 18.051 1.40369C17.8827 1.75867 17.8695 1.83001 17.8695 2.38726C17.8695 2.96724 17.8769 3.00311 18.0841 3.42185C18.4441 4.14922 19.0591 4.59643 19.8688 4.71969C20.799 4.86134 21.7142 4.44402 22.2222 3.64662C22.6346 2.99924 22.6904 2.04959 22.3566 1.35524C21.8695 0.341666 20.6893 -0.205687 19.614 0.0831905ZM1.6115 5.6543C1.17471 5.76002 0.620216 6.05084 0.289845 6.34752L0 6.60781V7.4281V8.24833H3.7905H7.58099V7.45953V6.67072L7.27667 6.38327C6.92772 6.05363 6.44253 5.79105 5.94373 5.66193C5.49297 5.54527 2.08677 5.5393 1.6115 5.6543ZM9.80399 5.66238C9.35831 5.7795 8.84246 6.05175 8.50137 6.34973L8.20799 6.6061V7.42725V8.24833H12H15.792L15.7763 7.41096L15.7605 6.5736L15.4329 6.31005C15.0449 5.998 14.6113 5.77654 14.157 5.65834C13.6905 5.53696 10.2691 5.54015 9.80399 5.66238ZM18.0237 5.66113C17.5917 5.77728 17.1494 6.00654 16.7721 6.31005L16.4445 6.5736L16.4287 7.41096L16.413 8.24833H20.2065H24L23.9843 7.41096L23.9685 6.5736L23.6265 6.29821C23.2237 5.97386 22.8432 5.77978 22.3748 5.65959C21.9003 5.53793 18.4774 5.53912 18.0237 5.66113ZM1.539 10.6702C1.539 10.6871 2.21171 11.43 3.03399 12.3213L4.52893 13.9416L11.9972 13.9395L19.4655 13.9373L20.805 12.4841C21.5417 11.6849 22.2175 10.9429 22.3068 10.8352L22.469 10.6395H12.004C6.24828 10.6395 1.539 10.6533 1.539 10.6702ZM5.28458 14.7529C5.34916 14.8234 6.39243 15.9565 7.60299 17.2711L9.80399 19.6612V22.8424C9.80399 25.3622 9.81881 26.0186 9.87524 25.9996C9.91446 25.9864 10.9015 25.6827 12.0688 25.3246L14.1911 24.6735L14.1921 22.1594L14.193 19.6453L16.4587 17.1879C17.7049 15.8365 18.733 14.7069 18.7435 14.6778C18.7551 14.6453 16.1285 14.6248 11.9648 14.6248H5.1671L5.28458 14.7529Z" fill="#5B93FF" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.assignDealers ?? 0}</b></h3>
                                    <h6>Assign Dealers</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#5a57b71a", padding: '19px 15px' }}>
                                    <svg width="24" height="26" viewBox="0 0 24 26" fill="#5B93FF1a" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.2205 0.0697543C1.72539 0.45946 0.973331 2.06719 1.64696 3.4338C2.34407 4.84819 4.26656 5.18825 5.40844 4.09918C6.66723 2.89869 6.246 0.779821 4.626 0.163523C4.23738 0.0156681 3.59299 -0.0273162 3.2205 0.0697543ZM11.406 0.0831905C10.7213 0.267084 10.1098 0.774014 9.81516 1.40198C9.6762 1.69821 9.66149 1.79214 9.66149 2.38425C9.66149 3.01421 9.66873 3.05344 9.85375 3.42168C10.752 5.2092 13.2944 5.17732 14.1526 3.36771C14.3223 3.00982 14.3355 2.939 14.3355 2.38425C14.3355 1.8304 14.3221 1.75833 14.1539 1.40369C13.8139 0.686622 13.1823 0.190053 12.4325 0.0502832C12.0283 -0.025039 11.7791 -0.0170683 11.406 0.0831905ZM19.614 0.0831905C18.9098 0.272322 18.3722 0.726532 18.051 1.40369C17.8827 1.75867 17.8695 1.83001 17.8695 2.38726C17.8695 2.96724 17.8769 3.00311 18.0841 3.42185C18.4441 4.14922 19.0591 4.59643 19.8688 4.71969C20.799 4.86134 21.7142 4.44402 22.2222 3.64662C22.6346 2.99924 22.6904 2.04959 22.3566 1.35524C21.8695 0.341666 20.6893 -0.205687 19.614 0.0831905ZM1.6115 5.6543C1.17471 5.76002 0.620216 6.05084 0.289845 6.34752L0 6.60781V7.4281V8.24833H3.7905H7.58099V7.45953V6.67072L7.27667 6.38327C6.92772 6.05363 6.44253 5.79105 5.94373 5.66193C5.49297 5.54527 2.08677 5.5393 1.6115 5.6543ZM9.80399 5.66238C9.35831 5.7795 8.84246 6.05175 8.50137 6.34973L8.20799 6.6061V7.42725V8.24833H12H15.792L15.7763 7.41096L15.7605 6.5736L15.4329 6.31005C15.0449 5.998 14.6113 5.77654 14.157 5.65834C13.6905 5.53696 10.2691 5.54015 9.80399 5.66238ZM18.0237 5.66113C17.5917 5.77728 17.1494 6.00654 16.7721 6.31005L16.4445 6.5736L16.4287 7.41096L16.413 8.24833H20.2065H24L23.9843 7.41096L23.9685 6.5736L23.6265 6.29821C23.2237 5.97386 22.8432 5.77978 22.3748 5.65959C21.9003 5.53793 18.4774 5.53912 18.0237 5.66113ZM1.539 10.6702C1.539 10.6871 2.21171 11.43 3.03399 12.3213L4.52893 13.9416L11.9972 13.9395L19.4655 13.9373L20.805 12.4841C21.5417 11.6849 22.2175 10.9429 22.3068 10.8352L22.469 10.6395H12.004C6.24828 10.6395 1.539 10.6533 1.539 10.6702ZM5.28458 14.7529C5.34916 14.8234 6.39243 15.9565 7.60299 17.2711L9.80399 19.6612V22.8424C9.80399 25.3622 9.81881 26.0186 9.87524 25.9996C9.91446 25.9864 10.9015 25.6827 12.0688 25.3246L14.1911 24.6735L14.1921 22.1594L14.193 19.6453L16.4587 17.1879C17.7049 15.8365 18.733 14.7069 18.7435 14.6778C18.7551 14.6453 16.1285 14.6248 11.9648 14.6248H5.1671L5.28458 14.7529Z" fill="#5B93FF" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.leadsConverted ?? 0}</b></h3>
                                    <h6>Leads Converted</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#5a57b71a", padding: '19px 15px' }}>
                                    <svg width="24" height="26" viewBox="0 0 24 26" fill="#5B93FF1a" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.2205 0.0697543C1.72539 0.45946 0.973331 2.06719 1.64696 3.4338C2.34407 4.84819 4.26656 5.18825 5.40844 4.09918C6.66723 2.89869 6.246 0.779821 4.626 0.163523C4.23738 0.0156681 3.59299 -0.0273162 3.2205 0.0697543ZM11.406 0.0831905C10.7213 0.267084 10.1098 0.774014 9.81516 1.40198C9.6762 1.69821 9.66149 1.79214 9.66149 2.38425C9.66149 3.01421 9.66873 3.05344 9.85375 3.42168C10.752 5.2092 13.2944 5.17732 14.1526 3.36771C14.3223 3.00982 14.3355 2.939 14.3355 2.38425C14.3355 1.8304 14.3221 1.75833 14.1539 1.40369C13.8139 0.686622 13.1823 0.190053 12.4325 0.0502832C12.0283 -0.025039 11.7791 -0.0170683 11.406 0.0831905ZM19.614 0.0831905C18.9098 0.272322 18.3722 0.726532 18.051 1.40369C17.8827 1.75867 17.8695 1.83001 17.8695 2.38726C17.8695 2.96724 17.8769 3.00311 18.0841 3.42185C18.4441 4.14922 19.0591 4.59643 19.8688 4.71969C20.799 4.86134 21.7142 4.44402 22.2222 3.64662C22.6346 2.99924 22.6904 2.04959 22.3566 1.35524C21.8695 0.341666 20.6893 -0.205687 19.614 0.0831905ZM1.6115 5.6543C1.17471 5.76002 0.620216 6.05084 0.289845 6.34752L0 6.60781V7.4281V8.24833H3.7905H7.58099V7.45953V6.67072L7.27667 6.38327C6.92772 6.05363 6.44253 5.79105 5.94373 5.66193C5.49297 5.54527 2.08677 5.5393 1.6115 5.6543ZM9.80399 5.66238C9.35831 5.7795 8.84246 6.05175 8.50137 6.34973L8.20799 6.6061V7.42725V8.24833H12H15.792L15.7763 7.41096L15.7605 6.5736L15.4329 6.31005C15.0449 5.998 14.6113 5.77654 14.157 5.65834C13.6905 5.53696 10.2691 5.54015 9.80399 5.66238ZM18.0237 5.66113C17.5917 5.77728 17.1494 6.00654 16.7721 6.31005L16.4445 6.5736L16.4287 7.41096L16.413 8.24833H20.2065H24L23.9843 7.41096L23.9685 6.5736L23.6265 6.29821C23.2237 5.97386 22.8432 5.77978 22.3748 5.65959C21.9003 5.53793 18.4774 5.53912 18.0237 5.66113ZM1.539 10.6702C1.539 10.6871 2.21171 11.43 3.03399 12.3213L4.52893 13.9416L11.9972 13.9395L19.4655 13.9373L20.805 12.4841C21.5417 11.6849 22.2175 10.9429 22.3068 10.8352L22.469 10.6395H12.004C6.24828 10.6395 1.539 10.6533 1.539 10.6702ZM5.28458 14.7529C5.34916 14.8234 6.39243 15.9565 7.60299 17.2711L9.80399 19.6612V22.8424C9.80399 25.3622 9.81881 26.0186 9.87524 25.9996C9.91446 25.9864 10.9015 25.6827 12.0688 25.3246L14.1911 24.6735L14.1921 22.1594L14.193 19.6453L16.4587 17.1879C17.7049 15.8365 18.733 14.7069 18.7435 14.6778C18.7551 14.6453 16.1285 14.6248 11.9648 14.6248H5.1671L5.28458 14.7529Z" fill="#5B93FF" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3 style={{ fontSize: '18px' }}><b>{StatsData?.topAgentName ?? ""}</b></h3>
                                    <h6>Top Agent</h6>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div className="row">

                        <div className="col-xs-12" >
                            <div className='graphcards'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                    <h5>Urja Agent Table</h5>
                                    <button className='btn btn-primary' style={{
                                        padding: '5px',
                                        color: " rgb(43, 120, 255)",
                                        border: "1px solid rgb(43, 120, 255)",
                                        backgroundColor: "rgb(255, 255, 255)",

                                        borderRadius: "5px"
                                    }} onClick={() => handleDownload()}>Download</button>
                                </div>
                                <div className="tablecard custom ">
                                    <div className='table-responsive'>
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Mobile Number</th>
                                                    <th>Email</th>
                                                    <th>Community Type</th>
                                                    {/* <th>Grade</th> */}
                                                    <th>Conversion %</th>
                                                    <th>Dealer Count</th>
                                                    <th>Total Leads</th>
                                                    <th>Converted Leads</th>
                                                    <th>Approved Auto Leads</th>
                                                    <th>Approved Manual Leads</th>
                                                    <th>Reject Auto Leads</th>
                                                    <th>Reject Manual Leads</th>
                                                    <th>Additional Credit Review</th>
                                                    <th>Active Status</th>
                                                    <th>AllCLoud Pushed Count</th>
                                                    <th>AllCLoud Finance Count</th>
                                                    <th>Important</th>
                                                    <th>Added On</th>


                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dealersData?.length > 0 ? dealersData?.map((val, id) => {
                                                        return (
                                                            <tr key={id}>
                                                                <td>{val?.amuAgentName || "-"}</td>
                                                                <td>{val?.mobileNumber || "-"}</td>
                                                                <td>{val?.emailId || "-"}</td>
                                                                <td>{val?.communityType || "-"}</td>
                                                                {/* <td>{val?.grade || "-"}</td> */}
                                                                <td>{val?.conversionPercentage ?? "0"}</td>
                                                                <td>{val?.dealerCount ?? "0"}&nbsp; <i class="fa fa-info-circle" aria-hidden="true" onClick={() => handleDealerPopup(true, [], val)}></i></td>
                                                                <td>{val?.totalLeads ?? "0"}</td>
                                                                <td>{val?.convertedLeads ?? "0"}</td>
                                                                <td>{val?.approvedAuto ?? "0"}</td>
                                                                <td>{val?.approvedManual ?? "0"}</td>
                                                                <td>{val?.rejectedAuto ?? "0"}</td>
                                                                <td>{val?.rejectedManual ?? "0"}</td>
                                                                <td>{val?.additionalCreditReview ?? "0"}</td>
                                                                <td>{val?.active == true ? "Yes" : "No" ?? "-"}</td>
                                                                <td>{val?.pushedAllCloudCount ?? "0"}</td>
                                                                <td>{val?.financeAllCloudCount ?? "0"}</td>
                                                                <td>{val?.important == true ? "Yes" : "No" ?? "-"}</td>
                                                                <td>{val?.addedOn ?? "-"}</td>
                                                            </tr>
                                                        )
                                                    })
                                                        : ''}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'end', marginTop: '15px' }}>
                                        <Pagination
                                            count={Math.ceil(dealersDataItems)}
                                            page={currentPage}
                                            onChange={handlePageChange}
                                            color="primary"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ marginBottom: '20px' }}>
                        <div className="col-lg-4 col-xs-12">
                            <div className='graphcards'>
                                <h5>Leads Conversion Rate</h5>
                                <hr />
                                <div className="chartDiv">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <PieChart width={400} height={400}>
                                            <Pie
                                                dataKey="value"
                                                data={PieData}
                                                cx="50%"
                                                cy="50%"
                                                outerRadius={80}
                                                label

                                            >
                                                {PieData?.length > 0 && PieData?.map((entry, index) => (
                                                    <Cell
                                                        key={`cell-${index}`}
                                                        fill={["#01647F", "#FF8158"][index % 2]}
                                                    />
                                                ))}
                                            </Pie>
                                            <Tooltip />
                                        </PieChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-xs-12">
                            <div className='graphcards'>
                                <h5>Urja Agent Activity Trends</h5>
                                <hr />
                                <div className="chartDiv">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <LineChart
                                            width={500}
                                            height={300}
                                            data={vehicleTypeList}
                                            barSize={30}
                                            margin={{
                                                top: 15,
                                                right: 15,
                                                left: 20,
                                                bottom: 10,
                                            }}
                                        >
                                            <CartesianGrid vertical={false} stroke="#030229"
                                                strokeDasharray="0"
                                                strokeWidth={0.49} />
                                            <XAxis dataKey="month" tickLine={false} axisLine={false} tick={{
                                                // angle: -20,
                                                // textAnchor: 'end',
                                                fontSize: 9
                                            }} />
                                            <YAxis axisLine={false} tickLine={false} />
                                            <Line dataKey="leadsAssigned" fill="#6FA6B5" />
                                            <Line dataKey="leadsConverted" fill="#014C60" />
                                            <Tooltip />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ marginBottom: '20px' }}>
                        <div className="col-sm-6 col-xs-12">
                            <div className='graphcards'>
                                <h5>Top Performing Urja Agents</h5>
                                <div className="tablecard custom table-responsive" style={{height:'335px',overflowY:'auto'}}>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th>Top Performer</th>
                                                <th>Agent Name</th>
                                                <th>Lead Converted</th>
                                                <th>Total Lead Assigned</th>
                                                <th>Conversion %</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                topDealersList?.length > 0 ? topDealersList?.map((value, id) => {
                                                    return (
                                                        <tr key={id}>
                                                            <td>{value?.rank || "-"}</td>
                                                            <td>{value?.communityName || "-"}</td>
                                                            <td>{value?.leadsConverted || "0"}</td>
                                                            <td>{value?.totalLeadsAssigned || "0"}</td>
                                                            <td>{value?.conversionRate || "0"}</td>
                                                        </tr>
                                                    )
                                                })
                                                    : ""}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12">
                            <div className='graphcards'>
                                <h5>Urja Agents Location</h5>
                                <div style={{ marginTop: '15px' }}>
                                    <CustomMapComponent dealerData={dealerLocaleData} TextType={"Urja Agent"} totalHeight={"307px"} showTotalDealer={true} />
                                </div>
                                <div style={{ marginTop: '15px',display:'flex',gap:'15px',justifyContent:'center',alignItems:'center' }}>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>Conversion Rate:</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#008000', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{`>= 80%`}</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#66CC66', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{'>= 60%'}</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#FFFF66', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{`>= 40%`}</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#FFA500', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{`>= 20%`}</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#FF0000', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{`< 20%`}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-lg-7 col-xs-12">
                            <div className='graphcards'>
                                <h5>Dealer Assignments</h5>
                                <hr />
                                <div className="chartDiv">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <BarChart
                                            width={500}
                                            height={300}
                                            data={vehicleTypeList}
                                            barSize={30}
                                            margin={{
                                                top: 15,
                                                right: 15,
                                                left: 20,
                                                bottom: 10,
                                            }}
                                        >
                                            <CartesianGrid vertical={false} />
                                            <XAxis dataKey="name" tickLine={false} axisLine={false} tick={{
                                                // angle: -20,
                                                // textAnchor: 'end',
                                                fontSize: 9
                                            }} />
                                            <YAxis axisLine={false} tickLine={false} />
                                            <Bar dataKey="value" fill="#6FA6B5" />
                                            <Bar dataKey="value" fill="#FFAF96" />
                                            <Tooltip />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div> */}


                    </div>
                </div>

                {
                    dealerPopup?.show ?
                        <div className="background-blur">

                            <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: '900px' }}>
                                <i onClick={() => handleDealerPopup(false, [], "")} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                                <div className="row from-group">
                                    <div className="col-xs-12" style={{ padding: '10px' }}>
                                        <h4 className="text-center" style={{ marginTop: '10px' }}>Urja Agent - Dealer Details</h4>
                                    </div>
                                </div>

                                <div className="row from-group" style={{ marginTop: '10px' }}>
                                    <div className="col-xs-12">
                                        <div className="graphcards" style={{ margin: '0', padding: '0' }}>

                                            <div className="tablecard custom table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                <table className='table'>
                                                    <thead>
                                                        <tr>
                                                            <th>Dealer Name</th>
                                                            <th>Mobile Number</th>
                                                            <th>Email</th>
                                                            <th>Community Type</th>
                                                            <th>Grade</th>
                                                            <th>Total Leads</th>
                                                            <th>Converted Leads</th>
                                                            <th>Approved Auto Leads</th>
                                                            <th>Approved Manual Leads</th>
                                                            <th>Reject Auto Leads</th>
                                                            <th>Reject Manual Leads</th>
                                                            <th>Additional Credit Review</th>
                                                            <th>Conversion %</th>
                                                            <th>Status Active</th>
                                                            <th>Important</th>
                                                            <th>Added On</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            dealerPopup?.data?.length > 0 ? dealerPopup?.data?.map((val, id) => {
                                                                return (
                                                                    <tr key={id}>
                                                                        <td>{val?.dealerName || "-"}</td>
                                                                        <td>{val?.mobileNumber || "-"}</td>
                                                                        <td>{val?.emailId || "-"}</td>
                                                                        <td>{val?.communityType || "-"}</td>
                                                                        <td>{val?.grade || "-"}</td>
                                                                        <td>{val?.totalLeads || "-"}</td>
                                                                        <td>{val?.convertedLeads || "-"}</td>
                                                                        <td>{val?.approvedAuto ?? "-"}</td>
                                                                        <td>{val?.approvedManual ?? "-"}</td>
                                                                        <td>{val?.rejectedAuto ?? "-"}</td>
                                                                        <td>{val?.rejectedManual ?? "-"}</td>
                                                                        <td>{val?.additionalCreditReview ?? "-"}</td>
                                                                        <td>{val?.conversionPercentage ?? "-"}</td>
                                                                        <td>{val?.active == true ? "Yes" : "No" ?? "-"}</td>
                                                                        <td>{val?.important == true ? "Yes" : "No" ?? "-"}</td>
                                                                        <td>{val?.addedOn ?? "-"}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                                : ""}

                                                    </tbody>
                                                </table>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'end', marginTop: '15px' }}>
                                                <Pagination
                                                    count={Math.ceil(TotalpopupPage)}
                                                    page={popupPageNo}
                                                    onChange={handlePageChangePopup}
                                                    color="primary"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        : ""}
            </div>
        </>
    )
}
